<template>
  <div id="bom-review-table-view">
    <div class="version-tag">
      <div class="version-raw"><span>Raw</span></div>
      <div class="version-state"></div>
      <div class="version-new"><span>{{ bomVersion.version }}</span></div>
    </div>
    <div class="bom-review-table-raw">
      <vxe-grid
        size="mini"
        height="auto"
        border
        row-key
        ref="xTableR"
        class="sortable-tree-demo"
        :columns="tableColumnR"
        :data="tableTreeData"
        :cell-class-name="cellClassR"
        :tree-config="{
          children: 'children',
          indent: 15,
          line: true,
          toggleMethod
        }">
        <template v-slot:type="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          <Icon type="ios-folder-open" v-if="row.children.length > 0" /> {{ getType(row[column.property], row.row_type) }}
        </template>
        <template v-slot:cellR="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          {{ row[column.property] }}
        </template>
      </vxe-grid>
    </div>
    <div class="bom-review-table-new">
      <vxe-grid
        size="mini"
        height="auto"
        border
        row-key
        ref="xTableN"
        class="sortable-tree-demo"
        :columns="tableColumnN"
        :data="tableTreeData"
        :cell-class-name="cellClassN"
        :tree-config="{
          children: 'children',
          indent: 15,
          line: true,
          toggleMethod
        }">
        <template v-slot:state="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          <span v-if="row.state === 'added'">
            <Icon type="md-add" /> <span style="color:transparent">{{ $t('bom_tool.review.diff.added') }}</span>
          </span>
          <span v-else-if="row.state === 'deleted'">
            <Icon type="md-remove" /> <span style="color:transparent">{{ $t('bom_tool.review.diff.deleted') }}</span>
          </span>
          <span v-else-if="row.state === 'modified'">
            <Icon type="md-create" /> <span style="color:transparent">{{ $t('bom_tool.review.diff.modified') }}</span>
          </span>
          <span v-else-if="row.state === 'ignored'">
            <Icon type="md-radio-button-off" /> <span style="color:transparent">{{ $t('bom_tool.review.diff.ignored') }}</span>
          </span>
        </template>
        <template v-slot:type="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          <Icon type="ios-folder-open" v-if="row.children.length > 0" /> {{ getType(row[column.property], row.row_type) }}
        </template>
        <template v-slot:cellN="{ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex }">
          {{ getNewContent(row, column.property) }}
        </template>
      </vxe-grid>
    </div>
    <Spin fix size="large" v-if="loading || loadingVersion">
      <slot name="loading"></slot>
    </Spin>
  </div>
</template>

<script>
import Vue from 'vue'
// eslint-disable-next-line
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import Sortable from 'sortablejs'
import VxeGridTableEnhancement from '@/plugin/sortablejs-ext/VxeGridTableEnhancement'
import VXETablePluginIView from 'vxe-table-plugin-iview'
import 'vxe-table-plugin-iview/dist/style.css'

Vue.use(VXETable)
VXETable.use(VXETablePluginIView)
Vue.prototype.$modal = VXETable.modal

Sortable.mount(new VxeGridTableEnhancement())

export default {
  data () {
    return {
      showHelpTip2: false,
      loading: true,
      tableTreeData: [],
      tableColumnR: [],
      tableColumnN: [],
      headerMap: [],
      scrolling: '',
      versions: [],
      typeNameMap: [
        {
          key: 'part',
          name: 'Part'
        },
        {
          key: 'assembly',
          name: 'Assembly'
        },
        {
          key: 'alternative',
          name: 'Alternative'
        },
        {
          key: 'document',
          name: 'Document'
        },
        {
          key: 'document_group',
          name: 'Document Group'
        },
        {
          key: 'top_level',
          name: 'Top Level'
        }
      ],
      headerOrder: [
        {
          key: 'type',
          width: 180
        },
        {
          key: 'line_quantity',
          width: 75
        },
        {
          key: 'chinese_name',
          width: 140
        },
        {
          key: 'name',
          width: 150
        },
        {
          key: 'mpn',
          width: 160
        },
        {
          key: 'specification',
          width: 260
        },
        {
          key: 'brand',
          width: 170
        },
        {
          key: 'designator',
          width: 200
        },
        {
          key: 'preferred_status',
          width: 100
        },
        {
          key: 'case_package',
          width: 100
        },
        {
          key: 'unit_name',
          width: 60
        },
        {
          key: 'part_number',
          width: 100
        },
        {
          key: 'notes',
          width: 200
        }
      ]
    }
  },
  props: {
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Object,
      required: true
    },
    bomVersion: {
      type: Object,
      required: true
    },
    loadingVersion: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.handleHeaderChange()
    this.handleRowChange()
    const debounced = _.debounce(() => {
      this.scrolling = ''
    }, 100)
    document.getElementsByClassName('bom-review-table-raw')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').addEventListener('scroll', () => {
      if (this.scrolling === '') {
        this.scrolling = 'raw'
      }
      if (this.scrolling !== 'new') {
        document.getElementsByClassName('bom-review-table-new')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollTop = document.getElementsByClassName('bom-review-table-raw')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollTop
        document.getElementsByClassName('bom-review-table-new')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollLeft = document.getElementsByClassName('bom-review-table-raw')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollLeft
      }
      debounced()
    })
    document.getElementsByClassName('bom-review-table-new')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').addEventListener('scroll', () => {
      if (this.scrolling === '') {
        this.scrolling = 'new'
      }
      if (this.scrolling !== 'raw') {
        document.getElementsByClassName('bom-review-table-raw')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollTop = document.getElementsByClassName('bom-review-table-new')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollTop
        document.getElementsByClassName('bom-review-table-raw')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollLeft = document.getElementsByClassName('bom-review-table-new')[0].querySelector('.vxe-table--body-wrapper.body--wrapper').scrollLeft
      }
      debounced()
    })
  },
  watch: {
    rows: {
      handler () {
        this.handleRowChange()
      },
      deep: true
    },
    columns: {
      handler () {
        this.handleHeaderChange()
      },
      deep: true
    }
  },
  methods: {
    getType (val, rowType) {
      if (typeof val !== 'undefined' && val !== '' && val !== null) {
        return val
      }
      for (let item of this.typeNameMap) {
        if (item.key === rowType) {
          return item.name
        }
      }
    },
    getNewContent (row, key) {
      if (row.diff.length === 0) {
        return row[key]
      }
      for (let item of row.diff) {
        if (item.index === key) {
          return item.newVal
        }
      }
      return row[key]
    },
    toggleMethod ({ expanded, row, column, columnIndex, $columnIndex }) {
      if (!expanded) {
        return false
      }
      return true
    },
    cellClassR ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
      let classes = ''
      if (row.state === 'added') {
        classes = 'row-diff-added'
      } else if (row.state === 'deleted') {
        classes = 'row-diff-deleted'
      } else if (row.state === 'modified') {
        classes = 'row-diff-modified'
      } else if (row.state === 'ignored') {
        classes = 'row-diff-ignored'
      }
      if (columnIndex > 1 && row.diff.length > 0) {
        for (let item of row.diff) {
          if (item.index === column.property) {
            classes = (classes === '' ? '' : classes + ' ') + 'cell-modified'
          }
        }
      }
      if (row.row_type === 'alternative') {
        if (columnIndex === 0) {
          return (classes === '' ? '' : classes + ' ') + 'row-alternative type-cell-alternative'
        }
        return (classes === '' ? '' : classes + ' ') + 'row-alternative'
      }
      return classes
    },
    cellClassN ({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
      let classes = ''
      if (row.state === 'added') {
        classes = 'row-diff-added'
      } else if (row.state === 'deleted') {
        classes = 'row-diff-deleted'
      } else if (row.state === 'modified') {
        classes = 'row-diff-modified'
      } else if (row.state === 'ignored') {
        classes = 'row-diff-ignored'
      }
      if (columnIndex > 0 && row.diff.length > 0) {
        for (let item of row.diff) {
          if (item.index === column.property) {
            classes = (classes === '' ? '' : classes + ' ') + 'cell-modified'
          }
        }
      }
      if (columnIndex === 0) {
        return (classes === '' ? '' : classes + ' ') + 'state-cell-alternative'
      }
      if (row.row_type === 'alternative') {
        if (columnIndex === 1) {
          return (classes === '' ? '' : classes + ' ') + 'row-alternative type-cell-alternative'
        }
        return (classes === '' ? '' : classes + ' ') + 'row-alternative'
      }
      return classes
    },
    handleHeaderChange () {
      this.tableColumnN = []
      this.tableColumnR = []
      this.headerMap = {}
      for (let col of this.headerOrder) {
        if (this.columns[col.key] !== null && typeof this.columns[col.key] !== 'undefined' && this.columns[col.key] !== '') {
          this.headerMap[`col_${this.columns[col.key]}`] = col.key
          let item = {
            title: this.$t(`bom_tool.edit.map_col.${col.key}`),
            field: `col_${this.columns[col.key]}`,
            width: (col.key === 'specification' || col.key === 'notes') ? null : col.width,
            minWidth: (col.key === 'specification' || col.key === 'notes') ? col.width : null,
            showOverflow: 'tooltip',
            treeNode: col.key === 'type',
            slots: {
              default: col.key === 'type' ? 'type' : 'cellR'
            }
          }
          this.tableColumnN.push(_.cloneDeep(item))
          this.tableColumnR.push(_.cloneDeep(item))
          if (col.key !== 'type') {
            this.tableColumnN[this.tableColumnN.length - 1].slots.default = 'cellN'
          }
        }
      }
      this.tableColumnN.unshift({
        title: ' ',
        field: `col_state`,
        width: 30,
        fixed: 'left',
        showOverflow: 'tooltip',
        slots: {
          default: 'state'
        }
      })
    },
    handleRowChange () {
      this.tableTreeData = rebuildRows(this.rows)
      if (this.tableTreeData.length > 0) {
        this.loading = false
        this.$nextTick(() => {
          this.$refs.xTableR.setAllTreeExpand(true)
          this.$refs.xTableN.setAllTreeExpand(true)
        })
      }

      function rebuildRows (rows) {
        let temp_rows = []
        for (let row of rows) {
          let temp_row = {
            children: [],
            row_type: row.row_type,
            alternatives: [],
            state: '',
            diff: []
          }

          if (row.children?.length > 0) {
            temp_row.children = rebuildRows(row.children)
          }
          if (row.alternatives?.length > 0) {
            rows.splice(rows.indexOf(row) + 1, 0, ...row.alternatives)
            row.alternatives = []
          }

          if (row.row_type === 'document' || row.row_type === 'document_group') {
            temp_row.state = 'ignored'
          } else if (row.row_data === null || typeof row.row_data === 'undefined') {
            temp_row.state = 'added'
          } else if (row.compare_row_data === null || typeof row.compare_row_data === 'undefined') {
            temp_row.state = 'deleted'
          }

          if (temp_row.state === 'added') {
            for (let [index, value] of row.compare_row_data.entries()) {
              temp_row[`col_${index}`] = value
            }
          } else if (temp_row.state === 'deleted' || temp_row.state === 'ignored') {
            for (let [index, value] of row.row_data.entries()) {
              temp_row[`col_${index}`] = value
            }
          } else {
            for (let [index, value] of row.row_data.entries()) {
              temp_row[`col_${index}`] = value
              let newVal = row.compare_row_data[index]
              if (typeof newVal !== 'string' && newVal !== null && typeof newVal !== 'undefined') {
                newVal = '' + newVal
              }
              if (index > 1 && !(value === newVal || (value === null && newVal === '') || (value === '' && newVal === null))) {
                temp_row.diff.push({
                  index: `col_${index}`,
                  newVal
                })
              }
              if (temp_row.diff.length > 0) {
                temp_row.state = 'modified'
              }
            }
          }

          temp_rows.push(temp_row)
        }
        return temp_rows
      }
    }
  }
}
</script>

<style lang="less">
.bom-review-table-raw, .bom-review-table-new {
  position: relative;
  height: ~"calc(100vh - 244.2px)";
  background-color: white;
  overflow: visible;
  display: inline-block;
  &.loading {
    overflow: hidden;
  }
  .vxe-table .vxe-tree-cell {
    padding-left: 1.2em;
  }
  .vxe-tree--btn-wrapper {
    display: none;
  }
  td.vxe-body--column {
    border-right: 1px solid #E8EAEC;
    border-bottom: 1px solid #E8EAEC;
  }
  div.vxe-tree--line-wrapper div.vxe-tree--line {
    border-bottom: none;
  }
  td.type-cell-alternative {
    div.vxe-tree-cell {
      padding-left: 30px;
    }
  }
  td.row-alternative {
    background-color: #F8F8F9;
    color: rgb(150, 150, 150);
  }
  td.state-cell-alternative {
    background-color: #F8F8F9;
    div.vxe-cell.c--tooltip {
      text-overflow: clip!important;
      user-select: none;
    }
  }
  div.vxe-table--fixed-left-wrapper {
    box-shadow: none!important;
  }
  td.row-diff-added {
    color: #19be6b;
    background-color: fade(#19be6b, 10%);
  }
  td.row-diff-deleted {
    color: #ed4014;
    background-color: fade(#ed4014, 10%);
  }
  td.row-diff-modified {
    color: #2d8cf0;
    background-color: fade(#2d8cf0, 10%);
  }
  td.cell-modified {
    background-color: fade(#2d8cf0, 30%);
  }
  td.row-diff-ignored {
    color: #d4d4d4;
    background-color: #fbfbfb;
  }
}
.bom-review-table-raw {
  width: ~"calc(50% - 14.5px)";
  td.row-diff-added {
    color: transparent;
    background-color: #fff;
    user-select: none;
    div.vxe-cell {
      width: 0;
      height: 24px;
      overflow: hidden;
    }
  }
}
.bom-review-table-new {
  width: ~"calc(50% + 14.5px)";
  td.row-diff-deleted:not(.state-cell-alternative), td.row-diff-ignored:not(.state-cell-alternative) {
    color: transparent;
    background-color: #fff;
    user-select: none;
    div.vxe-cell {
      width: 0;
      height: 24px;
      overflow: hidden;
    }
  }
  td.row-diff-added:not(.state-cell-alternative) {
    div.vxe-cell {
      height: 24px;
    }
  }
}
.version-tag {
  width: 100%;
  margin: 0;
  margin-top: 18px;
  background-color: #F8F8F9;
  border: 1px solid #E8EAEC;
  border-bottom: none;
  height: 35.2px;
  & > div {
    display: inline-block;
    padding: 10px;
    line-height: 15.2px;
    span {
      font-size: 12px;
      padding: 2px 4px;
      border: 1px solid #515a6ead;
      border-radius: 4px;
    }
    &.version-raw {
      width: ~"calc(50% - 14px)";
      border-right: 1.5px solid #E8EAEC;
    }
    &.version-state {
      width: 29px;
    }
    &.version-new {
      width: ~"calc(50% - 15px)";
      border-left: 1px solid #E8EAEC;
    }
  }
}
</style>
